import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import SpacePath from "components/SpacePath";

import { AzureIntegrationView } from "../../../useSearchCloudIntegrations/gql";

const IntegrationsAzureTableSpaceCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AzureIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath spaceId={item.spaceDetails.id} fallbackName={item.spaceDetails.name} />
    </TableSimpleCell>
  );
};

export default IntegrationsAzureTableSpaceCell;
